import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { useHistory } from 'react-router';
import PropTypes from 'prop-types';

import { modalConfirmationStyles } from './styles';
import Buttons from '../../../mis-datos/components/common/Buttons';

import { TICKETS_ROUTE } from '../../../../../constants/Routes';

import { closeModalSuccessCreate } from '../../../../../redux/actions/TicketActions';

import successIcon from '../../../../../assets/selfService/successModal.svg';
import successNoProductIcon from '../../../../../assets/selfService/successNoProductModal.svg';

const ModalConfirmation = (props) => {
  const { mobile } = props;
  const classes = modalConfirmationStyles({ mobile });
  const history = useHistory();
  const dispatch = useDispatch();
  const { profile } = useSelector((state) => state.profileReducer);
  const {
    modalInformation,
    openModalSuccessTicketCreate,
    selfService,
  } = useSelector((state) => state.ticketReducer);

  const goToTickets = () => {
    dispatch(closeModalSuccessCreate());
    history.push(TICKETS_ROUTE);
  };

  const handleClose = () => {
    dispatch(closeModalSuccessCreate());
  };

  return (
    <React.Fragment>
      <div className={classes.container}>
        <Dialog
          onClose={handleClose}
          open={openModalSuccessTicketCreate}
          maxWidth={'lg'}
          disableBackdropClick
          disableEscapeKeyDown
          classes={{
            paper: classes.paper,
          }}
        >
          <DialogTitle onClose={handleClose}>
            <IconButton
              aria-label="close"
              className={classes.closeButton}
              onClick={handleClose}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent className={classes.normalText}>
            <Typography>
              <img
                className={classes.image}
                src={
                  modalInformation.noProduct
                    ? successNoProductIcon
                    : successIcon
                }
              />
            </Typography>
            <Typography className={classes.title}>
              {selfService.selfService
                ? 'Cambio realizado con éxito'
                : 'Reporte enviado con éxito'}
            </Typography>
            {modalInformation.changeMessage && (
              <Typography className={classes.subtitle}>
                {modalInformation.changeMessage}
              </Typography>
            )}
            {modalInformation.newValue && (
              <Typography className={classes.purpleDetail}>
                {modalInformation.newValue}
              </Typography>
            )}
            <Typography className={classes.bodyText}>
              {modalInformation.noProduct ? (
                <React.Fragment>
                  Nuestras ejecutivas y ejecutivos estarán trabajando para
                  revisar tu solicitud y brindarte una pronta solución. <br />
                  Tu solicitud quedará guardada en{' '}
                  <a className={classes.link} onClick={goToTickets}>
                    “Solicitudes de atención”
                  </a>
                  , para que la puedas revisar cuando quieras.
                </React.Fragment>
              ) : (
                <React.Fragment>
                  Te enviamos la información al correo{' '}
                  <strong>{profile.email1}</strong> <br />
                  En caso de inconveniente, tu número de autoatención es:{' '}
                  <strong>{selfService.ticketId}</strong>
                </React.Fragment>
              )}
            </Typography>
          </DialogContent>
          <DialogActions>
            <div className={classes.buttonsContainer}>
              <Buttons
                modifiable={true}
                onCancelClick={handleClose}
                onSendClick={goToTickets}
                mobile={mobile}
                primaryButtonText={'Ver solicitud creada'}
                secondaryButtonText={'Cerrar'}
                marginRightButton={mobile ? 0 : 20}
                marginTop={15}
              />
            </div>
          </DialogActions>
        </Dialog>
      </div>
    </React.Fragment>
  );
};

ModalConfirmation.propTypes = {
  mobile: PropTypes.bool,
};

export default ModalConfirmation;
